import CommonReceiptA5, { type CommonReceiptA5Props } from "./CommonReceiptA5";
import AuthlessPrintChrome from "./AuthlessPrintChrome";
import { useAuthlessPrintRow, type UseAuthlessPrintRowOptions } from "./use-authless-print-row";

export type AuthlessA5PrintPageProps<T> = UseAuthlessPrintRowOptions<T> & {
  toProps: (row: T) => CommonReceiptA5Props;
};

/**
 * Shared authless fetch + loading/error chrome for CommonReceiptA5 print routes.
 * Domain screens supply location / id / row selection and a pure `toProps` mapper.
 */
function AuthlessA5PrintPage<T>({ toProps, ...fetchOptions }: AuthlessA5PrintPageProps<T>) {
  const state = useAuthlessPrintRow<T>(fetchOptions);

  return (
    <AuthlessPrintChrome {...state}>
      {(row) => <CommonReceiptA5 {...toProps(row)} />}
    </AuthlessPrintChrome>
  );
}

export default AuthlessA5PrintPage;
